// apps/client/src/utils/deleteOrganisationAndUsers.ts

import { apiClient } from './apiClient';
import { ApiResponseGeneric } from '@avanzu/types';

export const deleteUser = async (organisationId?: string | null): Promise<ApiResponseGeneric> => {
  try {
    if (!organisationId) {
      return {
        success: false,
        message: 'Organisation ID is required',
      };
    }

    const response = await apiClient.delete(`/user/profile`);
    const result = await response.json();

    if (!response.ok) {
      return {
        success: false,
        message: result.error || 'Failed to delete user account',
      };
    }

    return { success: true };
  } catch (error) {
    console.error('Error deleting organisation and users:', error);
    return {
      success: false,
      message:
        error instanceof Error ? error.message : 'An error occurred while deleting the account',
    };
  }
};

export default deleteUser;
